import ProductBrandLogo, { type ProductBrandLogoProps } from './ProductBrandLogo';

const ProductBrandLogoWithLink = (props: ProductBrandLogoProps) => (
    <a href="/?index=1" style={{ textDecoration: 'none' }}>
        <ProductBrandLogo {...props} />
    </a>
);

export default ProductBrandLogoWithLink;
